<template>
  <div>
    <!-- ページヘッダー -->
    <div class="container-fluid page-head-wrap">
      <div class="container page-head">
        <h3 class="h4 text-center">
          <!--<router-link :to="{ name: 'top', params: {} }">-->
            <!--<i class="fa fa-chevron-left back-icon" aria-hidden="true"></i>-->
          <!--</router-link>-->
          <b><trans-text i18nKey="ui[94][1]"/></b>
        </h3>
      </div>
    </div>
    <div class="container-fluid page-head-wrap">
      <div class="container page-head">
        <p class=" questionnaire-subhead mb-0"><trans-text i18nKey="ui[94][2]"/></p>
      </div>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-12 offset-lg-2 col-lg-8">
          <!--<div class="alert alert-danger mt-3" role="alert" v-if="apiErrorI18nKey">-->
            <!--<b><trans-text :i18nKey="apiErrorI18nKey"/></b>-->
          <!--</div>-->
          <!-- 入力フォーム -->
          <page-form @tryForm="tryForm"></page-form>

        </div>
      </div>
    </div>
  <thanks-demo-questionnaire-alert :input="input"></thanks-demo-questionnaire-alert>
  </div>
</template>

<script>
  import {dd,store,app} from 'systems/imports'
  import PageForm from 'page/partials/Order/DemoQuestionnaire/PageForm.vue'
  import ThanksDemoQuestionnaireAlert from 'components/modal/ThanksDemoQuestionnaireAlert.vue'

  export default {
    name:"",
    components: {
      PageForm,
      ThanksDemoQuestionnaireAlert
    },
    data () {
      return {
          input:{},
      }
    },
    created(){
    },
    methods:{
      tryForm(input){
        this.input = input
        $("#ThanksDemoQuestionnaireAlert").modal({backdrop: 'static', keyboard: false})
      }
    }
  }
</script>


<style lang="scss" scoped>
  .questionnaire-subhead{
    font-size: .8rem;
  }

</style>



// WEBPACK FOOTER //
// DemoQuestionnaire.vue?578d004d